import {
  fetchFilterData,
  fetchAgreementUtilizationList,
  fetchAgreementUtilizationDetail,
  fetchInstanceFamilyUtilizationList,
  fetchServiceUtilizationList,
  fetchTotalSummary,
  fetchTransition
} from '@/api/azure-reserved/azure-utilization';
import { isFutureMonth } from '@/util/dateTimeUtils';



const getFilterData = (context, payload) => {
  context.commit('SET_IS_FILTER_DATA_LOADING', true);
  fetchFilterData(payload).then((response) => {
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    context.commit('FILTER_DATA_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    console.error(error);
  });
};


const getAgreementUtilizationList = (context, payload) => {
  context.commit('SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING', true);
  fetchAgreementUtilizationList(payload).then((response) => {
    context.commit('SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING', false);
    context.commit('AGREEMENT_UTILIZATION_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING', false);
    console.error(error);
  });
};

const getAgreementUtilizationDetail = (context, payload) => {
  context.commit('SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING', true);
  fetchAgreementUtilizationDetail(payload).then((response) => {
    context.commit('SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING', false);
    context.commit('AGREEMENT_UTILIZATION_DETAIL_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING', false);
    console.error(error);
  });
};



const getInstanceFamilyUtilizationList = (context, payload) => {
  context.commit('SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING', true);
  fetchInstanceFamilyUtilizationList(payload).then((response) => {
    context.commit('SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING', false);
    context.commit('INSTANCE_FAMILY_UTILIZATION_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING', false);
    console.error(error);
  });
};

const getServiceUtilizationList = (context, payload) => {
  context.commit('SET_IS_SERVICE_UTILIZATION_LIST_LOADING', true);
  fetchServiceUtilizationList(payload).then((response) => {
    context.commit('SET_IS_SERVICE_UTILIZATION_LIST_LOADING', false);
    context.commit('SERVICE_UTILIZATION_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_SERVICE_UTILIZATION_LIST_LOADING', false);
    console.error(error);
  });
};

const getTotalSummary = (context, payload) => {
  context.commit('SET_IS_TOTAL_SUMMARY_LOADING', true);
  fetchTotalSummary(payload).then((response) => {
    context.commit('SET_IS_TOTAL_SUMMARY_LOADING', false);
    context.commit('TOTAL_SUMMARY_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_TOTAL_SUMMARY_LOADING', false);
    console.error(error);
  });
};

const getTransition = (context, payload) => {
  context.commit('SET_IS_TRANSITION_LOADING', true);
  fetchTransition(payload).then((response) => {
    context.commit('SET_IS_TRANSITION_LOADING', false);
    context.commit('TRANSITION_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_TRANSITION_LOADING', false);
    console.error(error);
  });
};


const selectedMonthToDate = (context, payload) => {
  context.commit('SET_ACTIVE_MONTH', payload);
};

const setDisplayedWarningBanner = (context, tabName) => {
  context.commit('SET_DISPLAYED_WARNING_BANNER', tabName);
}

const setSelectedViewByOption = (context, selectedViewBy) => {
  context.commit('SET_SELECTED_VIEW_BY_OPTION', selectedViewBy);
}

const setSelectedVendor = (context, selectedVendor) => {
  context.commit('SET_SELECTED_VENDOR', selectedVendor);
}

export default {
  getFilterData,
  getAgreementUtilizationList: getAgreementUtilizationList,
  getAgreementUtilizationDetail: getAgreementUtilizationDetail,
  getInstanceFamilyUtilizationList: getInstanceFamilyUtilizationList,
  getServiceUtilizationList: getServiceUtilizationList,
  getTotalSummary,
  getTransition,
  setDisplayedWarningBanner,
  selectedMonthToDate,
  setSelectedViewByOption,
  setSelectedVendor
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-utilization/actions.js